import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StackView, Typography, Box, Icon } from '@telus-uds/components-web';
import palette from '@telus-uds/palette-koodo';
import Icons from '@telus-uds/palette-koodo/build/web/icons';
export var PromoText = function (_a) {
    var icon = _a.icon, text = _a.text;
    if (!text)
        return _jsx("div", {});
    var pink = palette.color.pink;
    return (_jsx(Box, { horizontal: 2, vertical: 1, children: _jsxs(StackView, { direction: "row", space: 3, tokens: { alignItems: 'center' }, children: [_jsx(Icon, { icon: Icons[icon], accessibilityLabel: "tag icon", variant: { size: 'micro', color: 'brand' }, tokens: { color: pink.value } }), _jsx(Typography, { variant: { size: 'micro', bold: true }, children: text })] }) }));
};
